"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Title = exports.ImageWrapper = exports.BlockText = exports.Anchor = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var BlockText = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin: 0 0 32px 0;\n  ", "\n"])), function (_ref) {
  var $bsStyle = _ref.$bsStyle;
  return $bsStyle || '';
});
exports.BlockText = BlockText;
var Title = _styledComponents.default.h4(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  letter-spacing: 0.09px;\n  color: white;\n  margin-top: 0;\n  margin-bottom: 8px;\n  font-size: 16px;\n  font-weight: 800;\n  font-family: 'Gentleman', Arial, sans-serif;\n  @media screen and (max-width: 420px) {\n    font-size: 14px;\n  }\n"])));
exports.Title = Title;
var ImageWrapper = _styledComponents.default.img.attrs({
  alt: 'photo'
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  background-image: url(", ");\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  max-height: 500px;\n  max-width: 750px;\n  object-fit: cover;\n  @media screen and (max-width: 420px) {\n    width: 100%;\n  }\n"])), function (_ref2) {
  var url = _ref2.url;
  return url;
});
exports.ImageWrapper = ImageWrapper;
var Anchor = _styledComponents.default.a(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  font-family: 'Gentleman', Arial, sans-serif;\n  display: table-cell;\n  text-decoration: none;\n  color: #ffbe33;\n  font-weight: bold;\n  margin-bottom: 8px;\n  font-size: 16px;\n  @media screen and (max-width: 420px) {\n    font-size: 15px;\n  }\n  ", "\n"])), function (_ref3) {
  var $bsStyle = _ref3.$bsStyle;
  return $bsStyle || '';
});
exports.Anchor = Anchor;